<template>
  <div>
   
    <div v-if="show_servers_variables">
   
  
    <b-row v-show="show_servers_variables">
      <b-col>
        <b-tabs
          v-model="seltab"
        >
          <b-tab
            active
          >
            <template #title>
              <feather-icon icon="ServerIcon" />
              <span>Severs</span>
            </template>
            <b-card-code
              class="submain styled"
              title="Servers"
            >
        
              <servers 
             
                :servers="servers"
                :computing="computing"
                type="viewers"
              />
            </b-card-code>
          </b-tab>
          <b-tab
            :disabled="(!hasServer)"
            :active="(hasServer)"
          >
            <template #title>
              <feather-icon icon="CheckSquareIcon" />
              <span>Master Variables</span>
            </template>
            <b-card-code
              title="Master Variables"
              class="submain styled"
            >
              <b-row>
                <b-col md="12">
                  <block-input
                    v-for="item in masterVariables"
                    :key="item.name"
                    :data="item"
                    :value="masterValues[item.name]"
                    :disabled="computing"
                    :model-options="modelOptions"
                    server="server"
                    :user="1"
                    category="viewers"
                    @genVariable="generateVariable"
                  />
                </b-col>
              </b-row>
            </b-card-code>

          </b-tab>
        
        </b-tabs>
        </b-col>
        </b-row>
        
  
  </div>

  

    <loading
      :active="isLoading"
      :can-cancel="false"
      :is-full-page="false "
    />
    <b-alert
      v-height-fade.appear
      :show="false"
      :dismissible="false"
      class="mb-2"
      variant="danger"
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged"
    >
      <div class="alert-body">
        <span>Connnection lost. Retyrating connection after {{ dismissCountDown }} seconds...</span>
      </div>
    </b-alert>
    <b-card
      no-body
      class="viewer-tabs"
     

    
    >
  
      <template #header>
        <h6
          v-for="(item, index) in tabs"
          :key="index"
          class="mb-0"
          style="display:flex"
          :class="{ active: tabActive === index }"
          @click="tabActive = index"
        >
          {{ item.name }}
          <div> <feather-icon
            icon="XIcon"
            class="addTab"
            width="15"
            height="15"
            @click="delTab(item.id)"
          /></div>
        </h6>
        <div
          style="cursor: pointer; font-size:12px; display: flex;"
          @click="addTab"
        >
          <feather-icon
            icon="PlusIcon"
            class="addTab"
            width="18"
            height="18"
            style="margin-right: 5px"
          />
          ADD NEW TAB
        </div>
         
       
         
      </template>

    
   
      <b-col style="     text-align: initial;">
        <b-button
          v-show="(cont_pictures > 0 && edit_role == 1)"
          variant="primary"
          size="sm"
          class="mt-1"
          style="left:3rem; margin-top:40px"
          
          :disabled="edit_role == 0"
          @click="show_more"
        >
          ADD VIEWER
        </b-button>
      </b-col>
      <div id="paint-box">
        <b-button
          variant="primary"
          size="sm"
          class=""
          right:0
          style="border:0px !important; margin-top:8px"
       
          
          :disabled="edit_role == 0"
          @click="showObjects"
        >
        <feather-icon
                icon="EditIcon"
                style="margin: 0 5px;"
              />
          
        </b-button>
        <b-button
          variant=""
          size="sm"
          class=""
          right:0
          style="border:0px !important; margin-top:8px; margin-left:5px"
       
          
          @click="show_server_content"
        >
        <feather-icon
                icon="GridIcon"
                style="margin: 0 5px;"
              />
          
        </b-button>

      </div>
      
      <div id="paint-box-objects" v-show="show_object_paint">
      
          <div id="paint-content" >
              <div
                v-for="(item, i) in paintList"
                :key="i"
                class="paint"
                style="margin-top:10px"
              > <b-form-checkbox
                  v-model="item.selected"
             
                  @change="colorPickerChange(item.color, item.name, item.selected)"
                  class="custom-control-secondary"
                />
                <b-button
                  variant="outline-white"
                  style=";width: auto;height: 15px;padding: 0 !important;border:0px"
                  @click="editPaintList(item.name, item.color)"
                        name="Markers"
                      >
                      
                        <svg
                          height="15"
                          width="15"
                      >
                        <circle
                          cx="7.5"
                          cy="7.5"
                          r="7.5"
                          :fill="item.color"
                        />
                      
                  </svg>
                  </b-button>
                <!-- <input-color-picker
                  v-model="item.color"
                  v-b-tooltip.hover.right.v-primary
                  :title="i"
                  @change="colorPickerChange(item.color, item.name, item.selected)" 
                  @update="colorPickerChange(item.color, item.name, item.selected)"
                  @mousedown="colorPickerChange(item.color, item.name, item.selected)"
                />  -->
                <div
                  style="margin-left:5px"
                  class="marker-title"
                  v-b-tooltip.hover.right.v-primary
                  :title="Number(i+1)"
                  @click="editMarker(item.name, item.path)"
                >{{ item.name }}</div>
              </div>
              <div>
                <div
                  style="cursor: pointer; margin-left: 5px !important; margin-top: 5px; font-size:13px; display: flex;"
                  @click="addPaintItem"
                >
                  <feather-icon
                    icon="PlusIcon"
                    class=""
                    width="18"
                    height="18"
                    style=""
                  />
                ADD NEW ITEM
              </div>
              </div>
            </div> 
       
    </div>
     

      <!-- <b-col cols="10">
        <b-button
          v-show="!active_paint"
          variant="primary"
          size="sm"
          class="mt-1"
          style="background-color:white !important; color:blueviolet !important; border-color: blueviolet !important"
          left:0
          :disabled="true"
          @click="show_more"
        >
          PAINT MODE
        </b-button>
       

      </b-col> -->
      <div
        v-show="(cont_pictures > 0 && edit_role != 1) || (edit_role != 1)"
        style="color:red; margin-left:14px; margin-top:10px"
      >
        You could not edit this viewer at this moment. Another user is editing it.
      </div>
      <div
        id="info-box"
        ref="infoBox"
        class="b-card-text"
     
      >

        <b-row style="padding-bottom:10px">
          <b-col :md="12">
            <b-row>
              <b-col
                v-for="(tabs2,index) in multiples_tabs"
                :key="index"
                :md="md_data"
              >

                <marker-overlaper
                  v-for="(item, index) in tabs2"
                  :id="item.id"
                  ref="foo"
                  :key="'viewer_' + index"
                  :data="item.data"
                  :download-settings="item.download_settings"
                  :params="item.params"
                  :server="item.server_id"
                  :image="item.image"
                  :refresh-tab="refreshTab"
                  :update="update"
                  :task="(item.task === null) ? 0 : item.task"
                  :tab-update="tabUpdate"
                  :tab-id="tabId"
                  :show_marker="true"
                  :viewer_cont="cont_pictures"
                  :edit_role="edit_role"
                />

              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import Vue from 'vue'
import BlockInput from '../components/blockInputs.vue'
import servers from '../servers.vue'
import PaintEdition from './Types/PaintEdition.vue'
import NewPaintObject from './Types/NewPaintObject.vue'
import EditPaintList from './Types/EditPaintList.vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import {
  BAlert, BCard, BRow, BCol, BButton, BFormCheckbox, BFormGroup, BFormInput,BBadge, BTabs, BTab, BOverlay, BSpinner
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import { heightFade } from '@core/directives/animations'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import NewViewer from './NewViewer.vue'
import MarkerOverlaper from './Types/MarkerOverlaper.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import InputColorPicker from 'vue-native-color-picker'
import { VBTooltip  } from 'bootstrap-vue'


const {
  url, port, auth, websocket,
} = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}
export default {
  components: {
    BAlert,
    BCard,
    BRow,
    BCol,
    BButton,
    MarkerOverlaper,
    Loading,
    PaintEdition,
    InputColorPicker,
    BFormCheckbox,
    NewPaintObject,
    EditPaintList,
    servers,
    BTab,
    BBadge,
    BTabs,
    BOverlay,
    BSpinner,
    BCardCode,
    BlockInput
  },

  directives: {
    'height-fade': heightFade,
    'b-tooltip': VBTooltip,
 
  },
  data() {
    return {
      modelOptions: [],
      servers:[],
      server_selected:'',
      master:'',
      masterVariables: [],
      dependentVariables: [],
      computing: false,
      show_servers_variables:false,
      hasServer:false,
      tabUpdate: 0,
      isLoading: false,
      time2wait: false,
      tabActive: 0,
      tabs: [],
      tabData: [],
      update: 0,
      connection: null,
      dismissSecs: 10,
      wsAlert: false,
      dismissCountDown: 0,
      message: null,
      key: null,
      tabId: 0,
      project: null,
      multiples_tabs: [],
      cont_pictures: 0,
      md_data: 12,
      show_marker: true,
      edit_role: 0,
      checkTimeout: null,
      intervalData: null,
      active_paint:false,
      actual_paint:'',
      actual_viewer_id:0,
      seltab:0,
      masterValues:[],
      project_folder: '',
      show_object_paint:false,
      server_is_selected: false,
      paintList:[
       
    ]
   
    

    }
  },
  watch: {
    
    time2wait(value) {
      if (value == true) {
        this.time2wait = false
        this.getdata()
      }
    },
    async tabId(value) {
      await this.askRole()
      this.multiples_tabs = []

      await this.getdata()
      localStorage.setItem('tab_id', this.tabActive)
      this.ping_tab()
    },
    cont_pictures(value) {
      if (value == 1) { this.md_data = 12 } else { this.md_data = 6; this.show_marker = false }
    },
    message() {
      // console.log(this.message)
    },
    $route() {
      // this.ping()
      const tabing = localStorage.getItem('tab_id')
      console.log("TABING IS", tabing)
      if (this.$route.params.viewer !== undefined) {
        localStorage.setItem('tab_id', 0)
        for (let index = 0; index < this.tabs.length; index++) {
          const item = this.tabs[index]
          if (parseInt(item.id, 10) === parseInt(this.$route.params.viewer, 10)) {
            this.tabActive = index
            this.tabId = this.tabs[index].id
          }
        }
      }
    },
    tabActive() {
      const date = new Date()
      this.tabUpdate = date.getTime()
      this.tabId = this.tabs[this.tabActive].id
     // localStorage.setItem('tab_id', this.tabA)
      // this.getdata()
    },
  },
  async mounted() {
  
    
    await this.askRole()
   
    await this.getStatus()
    await this.getdata()
    this.timer = setInterval(() => {
      if(this.$route.name == 'Viewers' && this.show_servers_variables == true){
        this.getStatus()
      }
   
     
    }, 1000)
    await this.getInputs()
    await this.getSelectedServer()
    const new_in_viewers = localStorage.getItem('new_in_viewers')
        if(new_in_viewers == 1){
          if(this.server_is_selected == false || this.project_folder == ''){
          this.show_servers_variables = true;
          this.noServerPopup()
        
              }
           

        }
  },
  created() {
    var tabing = localStorage.getItem('tab_id')
    try{
      if(tabing > 0){
        this.tabActive = Number(tabing);
        this.tabId = this.tabs[this.tabActive].id
        this.tabActive()
      }
    }catch(e){}
   
    console.log("TABING IS", tabing)
    
    window.addEventListener('keydown', (e) => {
      const { paintList} = this
      if (e.key >= 0 && e.key <= 9){
        if(this.$route.name == 'Viewers'){
        try{
          const index = Number(e.key) + 1
          
          if(index > 0 && index <= 10){
            this.colorPickerChange(paintList[index-2].color, paintList[index-2].name, true)

          }
         
        }catch{}
      }
    
    }
    
     
    });
    this.$root.$refs.viewer = this
    this.intervalData = setInterval(this.ping_table, 3000)
  },
  computed: {
    ready() {
      if (this.hasServer === true) {
        this.show_servers_variables = false;
        return true
      }
      this.show_servers_variables = false;
      return false
    },
  },
  methods: {
    server_error(server){
  
      Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: "Some viewers could not be shown because the next server(s) is/are not available: '" + server + "'."
  
    })

    },
    show_server_content(){
      if(this.show_servers_variables){this.show_servers_variables = false}
      else{ this.show_servers_variables = true;}
    },
    getSelectedServer(){
      const { id } = this.$route.params
      axios.get(`${url}:${port}/viewer-server-id/${id}`, { headers }).then(result => {
        const { data } = result.data
        try{
          this.server_selected = data[0].viewer_server
        }
        catch(e){
          this.server_selected = ''
        }
      })

    },
    generateVariable(data) {
      if (data.input.type === 0 && data.input.visible === 1) {
        this.masterVariables[data.input.name] = data.value
      } else if (data.input.auto === 1 && data.input.visible === 1) {
        this.dependentValues[data.input.name] = data.value
        this.saveVariable(data.input.name, data.value)
      }
    },
    saveVariable(input, value) {
      const category = 'viewers'
      const data = JSON.stringify({ project: this.$route.params.id, value, category })
      axios.put(`${url}:${port}/project_variable/${input}`, data, { headers }).then(async result => {
      })
    },
    async getInputs() {
      //const masterArray =[{ auto:0, category: "downstream", name: 'project_folder', order:40, value:'maite', generate:[], original_name:'', type:'path',visble:1}]
      const { id } = this.$route.params
      const { project_folder} = this
      const masterVariables = []
      const masterValues = {}
      const dependentVariables = []
      const dependentValues = {}
      var server_not_founded = true
      await axios.get(`${url}:${port}/variables/${id}_downstream`, { headers }).then(result => {
        const { data } = result.data
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          if (element.auto === 0 && element.visible === 1) {
            if(element.name == 'project_folder'){
            server_not_founded = false
            element.original_name = element.name
            const name = (element.name === 'cores') ? 'number_of_cpus' : element.name
            element.name = name
            element.value = project_folder
            masterVariables.push(element)
            masterValues[name] = project_folder
            }
          } else if (element.auto === 1 && element.visible === 1) {
            element.original_name = element.name
            dependentVariables.push(element)
            dependentValues[element.name] = project_folder
          }
        }
       
      
        
       
        this.masterVariables = masterVariables
        this.dependentVariables = dependentVariables
        this.masterValues = masterValues
        this.dependentValues = dependentValues
      })
     // this.masterVariables = masterArray
     // this.masterValues['project_folder'] = 'maite'
    },
    async getStatus() {
      const { id } = this.$route.params
     // this.server_is_selected = false
      await axios.get(`${url}:${port}/viewers_servers_status/${id}`, { headers }).then(result => {
        const {
          dependent, master, hasServer, hasPipeline, status, downstream_computed, 
        } = result.data.data
        const { viewer_server, project_folder } = result.data
        this.status = result.data
        this.project_folder = project_folder
        this.hasServer = false
        this.server = viewer_server
        this.hasPipeline = hasPipeline
        var servers = result.data.servers.servers
        this.server_selected = viewer_server
        for(var i=0; i< servers.length; i++){
          if(servers[i]['id'] == viewer_server){ 
            servers[i]['selected'] = true; this.hasServer = true;
            this.server_is_selected = true
          
          }
          else{servers[i]['selected'] = false;  }
          
         // this.hasServer = false;
        }
   
    
       
       // this.servers = result.data.servers.servers
       if(servers != undefined){
        if(servers.length > 0){
          this.servers = servers;
        }
      

       }
       else{
        this.servers = []
       }
       


        // eslint-disable-next-line camelcase
       
      })
    },
    editPaintList(name, color){
      const { paintList, actual_viewer_id} = this
        const editPaintEdition = new Vue({
        ...EditPaintList,
        parent: this,
        propsData: {
          actual_viewer_id, 
         actual_name: name,
          paintList,
          colorPicker: color
        },
      }).$mount()
      this.$swal({
        html: editPaintEdition.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        width: '40%',
      }).then(async result => {
          if (result.dismiss == undefined) {
           this.getPaintData(actual_viewer_id)
          }
        })

      //getPaintData
    },
    showObjects(){
      if( this.show_object_paint ) { this.show_object_paint = false;}
      else { this.show_object_paint = true; }
      
    },
    addPaintItem(){
     const { actual_viewer_id, paintList } = this
     const editPaintEdition = new Vue({
       ...NewPaintObject,
       parent: this,
       propsData: {
        actual_viewer_id, 
        paintList
       },
     }).$mount()
     this.$swal({
       html: editPaintEdition.$el,
       showCloseButton: true,
       showCancelButton: false,
       showConfirmButton: false,
       width: '40%',
     })



    },
    colorPickerChange(color, name, selected){
      for(var i=0; i< this.paintList.length;i++){
        if(this.paintList[i].name != name){
          this.paintList[i].selected = false
        }else{
          this.paintList[i].selected = true
        }
      }
     
      if(selected){
        const data = this.$refs.foo
        for (let i = 0; i < data.length; i++) {
          data[i].changePaintValue(true, name, color)
       
      }
      }
      this.changePaintMode(false, name, color);
      this.updatePaintList()
    },
    async editPaintColor(item){
     
       const editPaintEdition = new Vue({
         ...PaintEdition,
         parent: this,
         propsData: {
           item, 
         },
       }).$mount()
       this.$swal({
         html: editPaintEdition.$el,
         showCloseButton: false,
         showCancelButton: true,
         showConfirmButton: true,
         width: '40%',
       })

   },
  
    handleInput(event){
      console.log(event)
    },
  
    changePaintMode(value, mode, color){
      this.active_paint = value;
 
      const data = this.$refs.foo
      // for (let i = 0; i < data.length; i++) {
      //     data[i].changePaintValue(value, mode, color)
       
      // }
    },
    ping_table() {
      this.$root.$refs.apps.ping_tab(this.tabId, this.$route.params.id)
    },

    load_viewer_image(img, task, data_all) {
      const data = this.$refs.foo
      for (let i = 0; i < data.length; i++) {
        {
          if (data[i]._props.task == Number(task)) {
            data[i].change_image(img, data_all)
          }
        }
      }
    },
    change_scene_parent(task, sum) {
      const data = this.$refs.foo
      for (let i = 0; i < data.length; i++) {
        if (data[i]._props.task != Number(task)) {
          data[i].changeSceneNew(sum)
        }
      }
    },
    change_all(task, region) {
      const data = this.$refs.foo
      for (let i = 0; i < data.length; i++) {
        if (data[i]._props.task != Number(task)) {
          this.blocked_group = true;
          data[i].refreshZoom(region, Number(task))
        }
      }
    },
    editAlert() {
      Swal.fire('You could not edit this version at this moment. Another user is editing this project')
    },
    askRole() {
      const user_id = localStorage.getItem('actual_user_id')
      if (user_id > 0) {
        axios.get(`${url}:${port}/ask_for_role/${this.tabId}/${user_id}`, { headers }).then(response => {
          if (response) {
            try {
              this.edit_role = response.data.role
              if (this.edit_role == 0) {}
            } catch (error) { console.log(error) }
          }
        })
      }
    },
    async getTypes() {
      const { id } = this.$route.params
      await axios.get(`${url}:${port}/viewer-types/${id}`, { headers }).then(response => {
        if (response) {
          const { types, servers } = response.data
          this.types = types
          this.servers = servers

          this.loaded = true
        }
      })
    },
    async show_more() {
      const type = 'marker_overlaper'
      const { id } = this.$route.params
      const {  server_selected } = this
      //const server = server
      const tabName = 'test'
      const show = 0
      const data = { tabName, server: server_selected, type }
      data.show = 0
      data.fk_multiscreen = this.tabId
      this.isLoading = true

      await axios.post(`${url}:${port}/viewer-create/${id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          await this.getTypes()
        }
      })
      // await this.sleep(3500)
      // await this.getdata();
      // this.isLoading = false;

      //  await this.wait2data()

      // this.cont_pictures += 1;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    ping_tab() {
      this.$root.$refs.apps.ping_tab(this.tabId, this.$route.params.id)
    },
    ping() {
      if (this.connection !== null) {
        const task = {

          task: 'webtool_ping', project: this.$route.params.id, sessionToken: localStorage.getItem('sessionToken'), route: this.$route.name,
        }
        this.connection.send(JSON.stringify(task))
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (dismissCountDown === 0) {
        this.wsAlert = false
        if (this.connection == null) { this.websocket_connection() }
      }
    },
    websocket_connection() {
      this.connection = new WebSocket(websocket)
      this.connection.onmessage = event => {
        const json = JSON.parse(event.data)
        if (json.action === 'connection') {
          this.key = json.key
          this.ping()
        } else {
          this.message = event.data
        }
      }
      this.connection.onopen = () => {
        this.ping()

        this.wsAlert = false
      }
      this.connection.onerror = () => {
        this.websocket_connection()
        this.wsAlert = true
        this.dismissCountDown = this.dismissSecs
      }
      this.connection.onclose = () => {
        this.websocket_connection()
        this.wsAlert = true
        this.dismissCountDown = this.dismissSecs
      }
    },
    noServerPopup(){
      Swal.fire({
                icon: 'warning',
                 title: 'Oops...',
               text: 'Please, select a server and check the project folder to continue. ',
               })

    },
    addTab() {
      if(this.server_selected == '' || this.server_selected == null || this.server_selected == undefined){
        this.show_servers_variables = true;
        
         
          return

      }
      const tabkey = new Date().getTime()
      const viewerTabForm = new Vue({
        ...NewViewer,
        parent: this,
        propsData: { tabkey, tabs: this.tabs, server_selected: this.server_selected },
      }).$mount()
      this.$swal({
        html: viewerTabForm.$el,
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        width: '70%',
      })
    },
    delTab(id) {
      axios.delete(`${url}:${port}/viewer-tab/${id}`, { headers }).then(() => {
        // console.log(response)
        document.location.reload()
      })
    },
    async getPaintData(id){
      await axios.get(`${url}:${port}/viewer-get-paint-list/${id}`, { headers }).then(response => {
        if (response) {
          try{
          var paintObject = JSON.parse(response.data.data[0].data)
          this.paintList = paintObject
          const selected_object = paintObject.filter(elem => elem.selected == true)
          try{
          const data = this.$refs.foo
         
            for (let i = 0; i < data.length; i++) {
                data[i].changePaintValue(false, selected_object[0].name, selected_object[0].color)
            
            }
          }catch(e){}
          }catch(e){
            
            paintObject = []
            paintObject.push({name:'Main object', color:'#FF0000', selected: true})
            this.paintList = paintObject
            this.updatePaintList()
            this.paintList = []
          }
        }
      }
      )

    },
    async updatePaintList(){
      const {actual_viewer_id } = this
  
      const {paintList} = this
      const data = { paintList: JSON.stringify(paintList)}
      axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
          
  
        }
      }).catch(err =>{
          console.log(err)
        })

    },
    notFoundServer(data, idToLookFor) {
   
    for (var i = 0; i < data.length; i++) {
        if (data[i].id == idToLookFor) {
            return false
        }
    }
    return true
  },
   async  check_viewer_server(data){

    await this.getStatus()

    console.log("DATAA", data, "SERVER AVA",)
      const { servers } = this
      var data2 = [] 

      var server_not_founds = []
      data.forEach(elem =>{
        if(this.notFoundServer(servers, elem.server_id)){
          server_not_founds.push(elem.server_id)
         
        }
        else{
          data2.push(elem)
        }
      
      
      })
      console.log("DATA2", data2, "NOT FOUND", server_not_founds)
      var server_not_found = server_not_founds.filter((value, index, array) => array.indexOf(value) === index);
      return { data2, server_not_found }
    

    },

    async getdata() {
      const { id } = this.$route.params
   

      console.log("ASK FOR DATA", id)
     await axios.get(`${url}:${port}/viewer/${id}`, { headers }).then(async response => {
        if (response) {
          console.log("response")
          
          this.isLoading = false

          const { data, project } = response.data
          const new_in_viewers = localStorage.getItem('new_in_viewers')
          localStorage.setItem('new_in_viewers',1)
         
            const { data2, server_not_found } = await this.check_viewer_server(data)
            console.log("data2", data2)
          if(new_in_viewers == 0){
          if(server_not_found.length  > 0){
            console.log("SERVER NOT FOUND")
            this.server_error(server_not_found)
            //return
          }

          }
         
         
          
          try {
            this.tabs = data2
            this.tabId = this.tabs[this.tabActive].id
            store.commit('title', project.name)
            store.commit('icon', 'GridIcon')
            store.commit('isProject', true)
            store.commit('isExperimental', false)
            store.commit('activeSec', 'viewers')
            this.update = new Date().getTime()
          } catch (error) {}
        }
      })
      console.log("HERE", this.tabs)
      this.multiples_tabs = []
      const here_data = []
      for (let i = 0; i < this.tabs.length; i++) {
        console.log("ID IS", this.tabs[i].id, "ID2", this.tabId)
        if (this.tabs[i].id == this.tabId) {
         
          this.actual_viewer_id = this.tabs[i].id
         
          // console.log("THIS TAB", this.tabs[i])
          if (this.tabs[i].multiscreen == 1) {
            const datas = await this.getMultiData(this.tabs[i].id)
            for (let j = 0; j < datas.length; j++) { here_data.push([datas[j]]) }
          } else {
            here_data.push([this.tabs[i]])
          }
        }
      }
      if (this.edit_role == 1) {
        this.cont_pictures = here_data.length
        this.multiples_tabs = here_data
      }
      this.active_paint = false;
      this.getPaintData(this.actual_viewer_id)
      // else
      // {
      //    Swal.fire({
      //           icon: 'error',
      //           title: 'Oops...',
      //           text: 'You could not edit this viewer at this moment.',
      //         })
      // }
    },
    async getMultiData(id) {
      this.cont_pictures = 0
      const moment_data = []

      const response = await axios.get(`${url}:${port}/multi-viewer/${id}`, { headers }).then(response => response)

      const { data } = response.data

      for (let i = 0; i < data.length; i++) {
        moment_data.push(data[i])
      }
      console.log("MOMENT DATA", moment_data)

      return moment_data
    },
    refreshTab() {
      //  this.getdata()
    },
  },
}
</script>
  <style>
  /*.viewer-tabs ul{
      background: #f8f8f8;
  }
  .viewer-tabs ul li.nav-item{
      padding: 0 10px;
      background: #ffffff;
      border-radius:  0.428rem 0.428rem 0 0;
      box-shadow: 0 0 15px rgb(34 41 47 / 10%);
      clip-path: inset(0px -15px 0px 0px);
  }
  .viewer-tabs ul li .nav-link:after {
      background: #ffffff!important;
  }*/
  .viewer-tabs .card-header {
    padding: 0;
    margin-bottom: 0;
    background-color: rgb(34 41 47 / 10%) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
    min-height: 37.8px;
  }
  .viewer-tabs .card-header h6 {
    opacity: 0.5;
    padding: 0.75rem 1.55rem;
    background: #fff !important;
    margin-bottom: -1px !important;
    border-bottom: #fff;
    border-radius: 0 0.428rem 0 0;
    cursor: pointer;
    margin-right: -10px;
  }
  .viewer-tabs .card-header h6.active {
    opacity: 1;
    padding: 0.75rem 1.25rem !important;
    margin-bottom: -1px !important;
    border-radius: 0.428rem 0.428rem 0 0;
    box-shadow: 0 0 15px rgb(34 41 47 / 10%);
    clip-path: inset(0px -15px 0px 0px);
  }
  .b-card-text {
    padding: 20px;
    min-height: 40vw;
  }
  .viewer-tabs {
    /* height: calc(100vh - 150px); */
    height: auto
  }
  .viewer-tabs .addTab {
    margin-left: 20px;
    cursor: pointer;
  }
.paint{
    padding: 5px 10px;
    display: inline-flex;
    align-items: center;
    width: 100%;
    cursor: default;
  }
  .paint-content{
    height: 600px;
    width: auto;
    /* overflow-y: auto; */
    background-color: white;
   
  } 
  #paint-box{
    position: absolute;
    right: 10px;
    display: flex;
    justify-content: right;
    margin-right: 10px;
    margin-top: 50px;
    border: 0px !important;
    width:180px;
  }
  #paint-box-objects{
    position: absolute;
    right: 0px;
    display: flex;
    justify-content: left;
    margin-right: 10px;
    margin-top: 88px;
    border: 1px solid black;
    width:180px;
    z-index: 10;
    padding-bottom: 15px;
    background-color: white;
  }

  </style>
